function liquidzProduto() {
  return {
    quantidade: 1,
    quantidadeOriginal: 1, // 👈 importante
    etapa: 'quantidade',
    tipoCompra: 'avulsa',
    saboresSelecionados: {},
    produtosSabores: [],
    precoBase: 0,
    sachesPorCaixa: 12,
    faixas: [], // [{ quantidade, desconto }] desconto em % (ex: 14 = 14%) — plano avulso
    faixasClube: [], // [{ quantidade, desconto }] desconto em % — plano assinatura/clube
    ingredienteModal: false,
    ingredienteSelecionado: {},
    abrirPopupBeneficios: false,
    planoAssinaturaSelecionado: '30', // valores possíveis: '30', '90', '180'
    mostrarBeneficios: true,
    freteCep: '',
    freteResultado: null,
    freteErro: '',
    freteCarregando: false,

    get totalSelecionado() {
      return Object.values(this.saboresSelecionados).reduce((a, b) => a + b, 0);
    },

    // ---- Promoção do sabor da semana (config em Configurações do tema) ----
    get promo() {
      const c = window.promoSemana;
      if (!c || !c.productId) return null;
      const re = /^\d{4}-\d{2}-\d{2}$/;
      if (!re.test(c.inicio || '') || !re.test(c.fim || '')) return null;
      const agora = Date.now();
      const ini = Date.parse(c.inicio + 'T00:00:00-03:00');
      const fim = Date.parse(c.fim + 'T23:59:59-03:00');
      if (isNaN(ini) || isNaN(fim) || agora < ini || agora > fim) return null;
      const percent = Number(c.percent) || 0;
      return percent > 0 ? { productId: c.productId, percent } : null;
    },

    // Nome do sabor em promoção, extraído do título do produto escolhido nas configurações
    get promoNome() {
      return this.saborDoTitulo(window.promoSemana && window.promoSemana.titulo);
    },

    // true quando a página aberta é do produto que está em promoção
    get paginaEhPromo() {
      const c = window.promoSemana;
      return !!(c && c.productId && c.paginaId && String(c.paginaId) === String(c.productId));
    },

    get promoFimTexto() {
      const f = (window.promoSemana && window.promoSemana.fim) || '';
      const [, m, d] = f.split('-');
      return d && m ? d + '/' + m : '';
    },

    get textoFaixaPromo() {
      const alvo = this.paginaEhPromo
        ? 'neste sabor'
        : (this.promoNome ? 'no sabor ' + this.promoNome : 'em um sabor selecionado');
      return alvo + ' · até ' + this.promoFimTexto + ' · só na compra única';
    },

    rolarParaSabores() {
      const el = document.querySelector('.etapa-sabores');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },

    promoAtiva(produto) {
      const p = this.promo;
      return !!p && produto.id == p.productId;
    },

    // Total estimado: o sabor da semana usa o desconto dele (não acumula com o
    // progressivo, vale o melhor); os demais usam o progressivo. Só compra única.
    get resumoTotal() {
      const q = this.quantidade;
      const original = this.precoBase * q;
      const tier = parseFloat(this.precoComDesconto(q));
      let final = tier * q;
      const p = this.promo;
      if (p && this.tipoCompra !== 'assinatura') {
        const promoQtd = this.produtosSabores
          .filter(x => x.id == p.productId)
          .reduce((a, x) => a + (this.saboresSelecionados[x.variant_id] || 0), 0);
        const precoPromo = Math.min(tier, this.precoBase * (1 - p.percent / 100));
        final = tier * (q - promoQtd) + precoPromo * promoQtd;
      }
      const pct = original > 0 ? Math.round((1 - final / original) * 100) : 0;
      return { original, final, pct };
    },

    get quantidadesDisponiveis() {
      const qtds = new Set(this.faixas.map(f => f.quantidade));
      qtds.add(1);
      return [...qtds].sort((a, b) => b - a);
    },

    faixaParaQtd(qtd) {
      const ordenadas = [...this.faixas].sort((a, b) => b.quantidade - a.quantidade);
      const encontrada = ordenadas.find(f => qtd >= f.quantidade);
      return encontrada ? encontrada.desconto : 0;
    },

    precoComDesconto(qtd) {
      const desconto = this.faixaParaQtd(qtd) / 100;
      return (this.precoBase * (1 - desconto)).toFixed(2);
    },

    precoOriginal(qtd) {
      return this.precoBase.toFixed(2);
    },

    faixaClubeParaQtd(qtd) {
      if (!this.faixasClube.length) {
        return Math.min(100, this.faixaParaQtd(qtd) + 5); // fallback: +5% extra sobre o avulso
      }
      const ordenadas = [...this.faixasClube].sort((a, b) => b.quantidade - a.quantidade);
      const encontrada = ordenadas.find(f => qtd >= f.quantidade);
      return encontrada ? encontrada.desconto : 0;
    },

    precoClube(qtd) {
      const desconto = this.faixaClubeParaQtd(qtd) / 100;
      return (this.precoBase * (1 - desconto)).toFixed(2);
    },

    economia(qtd) {
      const original = this.precoBase;
      const comDesconto = parseFloat(this.precoComDesconto(qtd));
      return ((original - comDesconto) * qtd).toFixed(2);
    },

    async init() {
      try {
        this.produtosSabores = (window.produtosSabores || []).map(p => ({
          ...p,
          available: p.available !== false && p.available !== 'false',
          pre_venda: p.pre_venda === true
        }));
      } catch (err) {
        console.error('Erro ao carregar sabores:', err);
      }

      const wrapper = document.querySelector('[data-preco]');
      this.precoBase = parseFloat(wrapper?.dataset?.preco || 0);
      this.sachesPorCaixa = parseInt(wrapper?.dataset?.sachesPorCaixa || 12, 10);
      this.faixas = window.faixasQuantidade && window.faixasQuantidade.length
        ? window.faixasQuantidade
        : [{ quantidade: 4, desconto: 14 }, { quantidade: 3, desconto: 10 }, { quantidade: 2, desconto: 5 }, { quantidade: 1, desconto: 0 }];
      this.faixasClube = window.faixasClube || [];

      const maiorQtd = this.quantidadesDisponiveis[0] || 1;
      this.quantidade = maiorQtd;
      this.quantidadeOriginal = maiorQtd;
    },

    // Extrai o sabor do título. Aceita:
    //  "Eletrólitos em Pó Abacaxi com Hortelã - Água na Caixa..."  -> "Abacaxi com Hortelã"
    //  "Display com 12 Sachês de Eletrólitos em pó sabor Limão - ..." -> "Limão"
    saborDoTitulo(titulo) {
      const t = titulo || '';
      const m = t.match(/sabor\s+(.+?)\s+-\s/i)
        || t.match(/\bP[óo]\s+(.+?)\s+-\s/i)
        || t.match(/sabor\s+(.+)$/i);
      if (!m) return '';
      const n = m[1].trim();
      return n.charAt(0).toUpperCase() + n.slice(1);
    },

    nomeSabor(produto) {
      return this.saborDoTitulo(produto.title) || produto.title;
    },

    // Troca a quantidade de caixas; se já houver mais sabores escolhidos do que
    // caixas, remove o excesso (começando pelos ids maiores).
    selecionarQuantidade(q) {
      this.quantidade = q;
      this.quantidadeOriginal = q;
      let excesso = this.totalSelecionado - q;
      if (excesso <= 0) return;
      const ids = Object.keys(this.saboresSelecionados).reverse();
      for (const id of ids) {
        while (excesso > 0 && this.saboresSelecionados[id] > 0) {
          this.saboresSelecionados[id]--;
          excesso--;
        }
        if (excesso <= 0) break;
      }
    },

    incluirSabor(id) {
      this.saboresSelecionados[id] = (this.saboresSelecionados[id] || 0) + 1;
      const total = this.totalSelecionado;
      if (total > this.quantidade) {
        this.quantidade = total;
      }
    },

    removerSabor(id) {
      if (this.saboresSelecionados[id] > 0) {
        this.saboresSelecionados[id]--;
        const total = this.totalSelecionado;
        if (total < this.quantidade && this.quantidade > this.quantidadeOriginal) {
          this.quantidade = Math.max(this.quantidadeOriginal, total);
        }
      }
    },

    abrirIngrediente(produto) {
      this.ingredienteSelecionado = produto;
      this.ingredienteModal = true;
    },

    algumEmPreVenda() {
      return Object.entries(this.saboresSelecionados).some(([id, qtd]) => {
        const produto = this.produtosSabores.find(p => p.variant_id == id);
        return produto && produto.pre_venda === true && qtd > 0;
      });
    },

    async adicionarAoCarrinho() {
      const entradas = Object.entries(this.saboresSelecionados).filter(([_, qtd]) => qtd > 0);
      const tipoCompra = this.tipoCompra;

      const sellingPlanIdPorVariant = (variantId, planoSelecionado) => {
        const produto = this.produtosSabores.find(p => p.variant_id == variantId);
        return produto?.selling_plans?.[planoSelecionado] || null;
      };

      const items = entradas.map(([id, quantity]) => {
        const item = {
          id: id,
          quantity: quantity
        };

        if (tipoCompra === 'assinatura') {
          const sellingPlanId = sellingPlanIdPorVariant(id, this.planoAssinaturaSelecionado);
          if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
          }
        }

        return item;
      });

      console.log('Itens sendo enviados:', items);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          console.error('Erro ao adicionar ao carrinho');
          return;
        }

        setTimeout(async () => {
          const cart = await fetch('/cart.js').then(r => r.json());
          if (cart.items && cart.items.length > 0) {
            window.dispatchEvent(new Event('cart-change'));
            window.dispatchEvent(new Event('show-cart'));
          } else {
            console.warn('Carrinho vazio após tentativa de adição');
          }
        }, 500);

      } catch (error) {
        console.error('Erro ao adicionar produtos ao carrinho:', error);
      }
    },

    async calcularFrete(cepRaw) {
      const cep = (cepRaw || '').replace(/\D/g, '');
      if (cep.length !== 8) return;

      this.freteCarregando = true;
      this.freteErro = '';
      this.freteResultado = null;

      let lineKey = null;

      try {
        const cepRes = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        if (!cepRes.ok) throw new Error('cep-failed');
        const cepData = await cepRes.json();
        if (cepData.erro) {
          this.freteErro = 'CEP não encontrado.';
          return;
        }

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: window.produtoVariantId, quantity: 1 }] })
        });

        if (!addRes.ok) throw new Error('add-failed');
        const addData = await addRes.json();
        lineKey = addData.items && addData.items[0] ? addData.items[0].key : null;

        const params = new URLSearchParams({
          'shipping_address[zip]': cep,
          'shipping_address[country]': 'BR',
          'shipping_address[province]': cepData.estado,
          'shipping_address[city]': cepData.localidade
        });
        const ratesRes = await fetch(`/cart/shipping_rates.json?${params.toString()}`);
        if (!ratesRes.ok) throw new Error('rates-failed');
        const ratesData = await ratesRes.json();

        this.freteResultado = (ratesData.shipping_rates || []).map(rate => ({
          name: rate.presentment_name || rate.name,
          price: parseFloat(rate.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        }));

        if (!this.freteResultado.length) {
          this.freteErro = 'Nenhuma opção de frete encontrada para esse CEP.';
        }
      } catch (error) {
        console.error('Erro ao calcular frete:', error);
        this.freteErro = 'Não foi possível calcular o frete agora. Tente novamente.';
      } finally {
        if (lineKey) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: lineKey, quantity: 0 })
            });
            window.dispatchEvent(new Event('cart-change'));
          } catch (cleanupError) {
            console.error('Erro ao limpar item temporário do carrinho:', cleanupError);
          }
        }
        this.freteCarregando = false;
      }
    }
  };
}


// fora do return
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 768) {
    const splideEl = document.querySelector('.splide');
    if (splideEl) {
      new Splide(splideEl, {
        type: 'loop',
        perPage: 1,
        pagination: true,
      }).mount();
    }
  }
});